import { Component, OnInit, Input } from '@angular/core';
import * as feather from 'feather-icons';

@Component({
  selector: 'app-public-feather-icons',
  templateUrl: './public-feather-icons.component.html',
  styleUrls: ['./public-feather-icons.component.scss']
})
export class PublicFeatherIconsComponent implements OnInit {

  @Input('icon') public icon;

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

}
